import { DrawCustomMode, DrawCustomModeThis } from "@mapbox/mapbox-gl-draw";

import drawLineString from "fond/draw/modes/base/drawLineString";
import drawAerialSpan from "fond/draw/modes/planner/aerial/drawAerialSpan";
import { LayerIds } from "fond/types";

/**
 * A composite draw_line_string mode that merges base and aerial behavior.
 *
 * When the editingLayerId is inSpan, delegates onStop to drawAerialSpan which
 * decomposes the drawn line into individual span segments and creates poles
 * at each vertex.
 *
 * For all other layers, uses the base drawLineString behavior.
 */
const compositeDrawLineString: DrawCustomMode = {
  ...drawLineString,

  onStop(this: DrawCustomModeThis, state: Record<string, unknown>) {
    const editingLayerId = this._ctx.options.editOptions?.editingLayerId;

    if (editingLayerId === LayerIds.inSpan) {
      // @ts-expect-error ThisType constraints too strict for composite delegation
      return drawAerialSpan.onStop?.call(this, state);
    }

    // @ts-expect-error ThisType constraints too strict for composite delegation
    return drawLineString.onStop?.call(this, state);
  },
};

export default compositeDrawLineString;
